export default __webpack_public_path__ + "static/media/XMark.0d51cb3d.png";